import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeModal } from '../../actions/close-modal';
import Modal from '../../components/modal';
import DeleteConfirmation from '../../components/delete-confirmation';
import withTranslate from '../../hoc/with-translate';

export const DeleteCategoryModal = ({ closeModal, deleteCategory, t }) =>
  <Modal onClose={closeModal}>
    <DeleteConfirmation
      title={t('delete-category-modal.delete-category')}
      message={t('delete-category-modal.will-delete-posts-and-comments')}
      onConfirm={deleteCategory}
      onCancel={closeModal}
    />
  </Modal>;

DeleteCategoryModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  categoryId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      deleteCategory: () => closeModal(ownProps.categoryId),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(DeleteCategoryModal));



// WEBPACK FOOTER //
// ./app/containers/delete-category-modal/delete-category-modal.js